import React from 'react';
import Card from '../cards/card';
import Skeleton from './Skeleton';

interface LoadingDataAssetCardsProps {
    size?: number;
}

const LoadingDataAssetCards: React.FC<LoadingDataAssetCardsProps> = ({ size = 10 }) => {
    return (
        <div className="space-y-4">
            {[...Array(size)].map((_, index) => (
                <Card key={index} className="max-h-[100px]">
                    <div className="flex justify-between">
                        <div className="w-full">
                            <Skeleton className="mb-2 h-5 w-2/3" />
                            <Skeleton className="h-4 w-1/3" />
                        </div>
                        <Skeleton className="ml-4 h-6 w-6 flex-shrink-0" />
                    </div>
                </Card>
            ))}
        </div>
    );
};

export default LoadingDataAssetCards;